"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseFieldInput = void 0;
var React = __importStar(require("react"));
var Input_1 = __importDefault(require("@material-ui/core/Input"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var FormControl_1 = require("@material-ui/core/FormControl");
var useStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions;
    return ({
        root: {
            cursor: "pointer",
            minWidth: spacing(7),
            transition: transitions.create("min-width", {
                duration: transitions.duration.short,
            }),
            "&&": {
                marginTop: 0,
            },
            "& [class*='MuiInputAdornment-positionEnd']": {
                paddingRight: 0,
                opacity: 0,
                pointerEvents: "none",
                transition: transitions.create("opacity", {
                    duration: transitions.duration.short,
                }),
            },
            "&::before": {
                content: "''",
                position: "absolute",
                left: 0,
                bottom: 0,
                right: 0,
                borderBottom: "1px solid transparent",
                transition: transitions.create("border-bottom-color", {
                    duration: transitions.duration.short,
                }),
            },
            "&.Mui-focused, &:focus-within": {
                minWidth: function (_a) {
                    var expandWidth = _a.expandWidth;
                    return expandWidth;
                },
                cursor: "auto",
                "& [class*='MuiInputAdornment-positionEnd']": {
                    opacity: 1,
                    pointerEvents: "auto",
                },
                "&::before": {
                    borderBottomColor: palette.divider,
                },
            },
        },
        filled: {
            minWidth: function (_a) {
                var expandWidth = _a.expandWidth;
                return expandWidth;
            },
            cursor: "auto",
            "& [class*='MuiInputAdornment-positionEnd']": {
                opacity: 1,
                pointerEvents: "auto",
            },
            "&::before": {
                borderBottomColor: palette.divider,
            },
        },
        adornment: {
            minWidth: spacing(7),
            pointerEvents: "none",
            color: palette.text.primary,
            "&&&": {
                alignSelf: "unset",
                padding: spacing(0, 0, 0, 1),
            },
        },
        field: {
            // Only take as much space as is available
            flex: "1 0 0",
            width: 0,
            height: function (_a) {
                var fieldHeight = _a.fieldHeight;
                return fieldHeight;
            },
            opacity: 0,
            transition: transitions.create(["opacity"], {
                duration: transitions.duration.short,
            }),
            cursor: "inherit",
            "&&&": {
                padding: spacing(1, 0),
            },
            "$filled &, .Mui-focused &, $root:focus-within &": {
                cursor: "auto",
                opacity: 1,
            },
        },
    });
});
var CollapseFieldInput = function (_a) {
    var _b;
    var className = _a.className, expandWidth = _a.expandWidth, fieldHeight = _a.fieldHeight, _c = _a.inputProps, _d = _c === void 0 ? {} : _c, fieldClassName = _d.className, inputProps = __rest(_d, ["className"]), startIcon = _a.startIcon, other = __rest(_a, ["className", "expandWidth", "fieldHeight", "inputProps", "startIcon"]);
    var formControlState = FormControl_1.useFormControl();
    var filled = (formControlState !== null && formControlState !== void 0 ? formControlState : {}).filled;
    var classes = useStyles({
        expandWidth: expandWidth,
        fieldHeight: fieldHeight,
        filled: filled,
    });
    return (React.createElement(Input_1.default, __assign({ className: clsx_1.default(classes.root, className, (_b = {}, _b[classes.filled] = filled, _b)), inputProps: __assign({ className: clsx_1.default(classes.field, fieldClassName) }, inputProps), startAdornment: startIcon && (React.createElement(InputAdornment_1.default, { className: classes.adornment, position: "start" }, startIcon)) }, other)));
};
exports.CollapseFieldInput = CollapseFieldInput;
//# sourceMappingURL=CollapseFieldInput.js.map